import axios from 'axios';
import { dashboardDomain } from './ApiHelper';

class IdleTimer {
    
    constructor({ timeout, onTimeout, renewTokenTime, onExpired }) {
      this.timeout = timeout;
      this.onTimeout = onTimeout;
      this.renewTokenTime = renewTokenTime;
      this.lastTokenTime = (new Date()).getTime();
  
    // checks to see if the page has already expired.  Good for multitabs but it breaks if the localstorage doesnt get cleared before the next login
    //   const expiredTime = parseInt(localStorage.getItem('_expiredTime'), 10);
    //   if (expiredTime > 0 && expiredTime < Date.now()) {
    //       console.log('expiredTime',expiredTime);
    //     onExpired();
    //     return;
    //   }
  
      this.eventHandler = this.updateExpiredTime.bind(this);
      this.tracker();
      this.startInterval();
    }
  
    fetchToken = async () => {
        let response = await axios.get(`${dashboardDomain}code/database.php?function=updateMM&params=${sessionStorage.getItem('token')}~${sessionStorage.getItem('userID')}`); 
        sessionStorage.setItem('token',response.data.revised); 
    }

    startInterval() {
      this.updateExpiredTime();
  
      this.interval = setInterval(() => {
        const currentTime = (new Date()).getTime();
        if(currentTime > this.lastTokenTime+(this.renewTokenTime*1000)){
          this.lastTokenTime = currentTime;
          this.fetchToken();
        }

        const expiredTime = parseInt(localStorage.getItem('_expiredTime'), 10);
        if (expiredTime < Date.now()) {
          if (this.onTimeout) {              
            this.onTimeout();
            this.cleanUp();
            console.log('Expired from IdleTimer: '+expiredTime);
            window.location.href = 'https://online.essentialskills.com/login.php?haserror=true';
          }
        }
      }, 1000);
    }
  
    updateExpiredTime() { // gets called on input interaction
      if (this.timeoutTracker) { // dont update expire time until input has stopped
        clearTimeout(this.timeoutTracker);
      }
      this.timeoutTracker = setTimeout(() => { // input has stopped so reset the expire time
        localStorage.setItem('_expiredTime', Date.now() + this.timeout * 1000);
      }, 300);
    }
  
    tracker() {
      window.addEventListener('mousemove', this.eventHandler);
      window.addEventListener('scroll', this.eventHandler);
      window.addEventListener('keydown', this.eventHandler);
    }
  
    cleanUp() {
      localStorage.removeItem('_expiredTime');
      clearInterval(this.interval);
      window.removeEventListener('mousemove', this.eventHandler);
      window.removeEventListener('scroll', this.eventHandler);
      window.removeEventListener('keydown', this.eventHandler);
    }
  }
  export default IdleTimer;